//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'swiper/dist/css/swiper.css'
import {swiper,swiperSlide} from 'vue-awesome-swiper';
import sightData from '../../testdata/sight';
import {mapActions} from 'vuex';
import force from '../../common/forceLandscape';
  export default {
      name: "topic",
    components:{
      swiper,
      swiperSlide
    },
    data(){
        return{
          swiperOptions:{
            noSwiping:true,
            touchMoveStopPropagation:false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            on:{
              slideChange: ()=>{
                this.index=this.$refs.swiper.swiper.activeIndex;
              },
            },
          },
          index:0,
          sightData:[],
          buildData:[],
          error:0,
          zhengque:0
        }
    },
    methods:{
        ...mapActions(['changeTestStatus']),
      shuffle(){
        this.sightData.sort(()=>{
          return Math.random()-0.5;
        })
        return Promise.resolve('success');
      },
      checkAnswer(res){
          // res=true    //测试用
        var swiperindex=this.$refs.swiper.swiper.activeIndex;
        if(!res){
          this.$vux.toast.text('回答错误','center');
          this.error++;
          if(this.error>=5){
            this.changeTestStatus({name:'sight',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
              this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
            });
          }
        }else{
          this.zhengque++;
          this.$vux.toast.text('回答正确','center');
        }
        if(swiperindex>=7){
          this.changeTestStatus({name:'sight',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
            this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
          });
        }
        this.$refs.swiper.swiper.slideTo(swiperindex+1);
      },
    },
    created() {
      var routename=this.$route.name;
      var tixing=this.$store.state.tixing['lv'+this.$store.state.testLevel];
      var index=tixing.indexOf(routename);
      var title=`Test ${index+1} ${this.$store.state.title['lv'+this.$store.state.testLevel][index]}`;
      document.title=title;
        this.sightData=sightData['lv'+this.$store.state.testLevel];
        this.shuffle().then(_=>{
          this.buildData=this.sightData.slice(0,8);
        })
    },
    mounted() {
        force();
    }
  }



// WEBPACK FOOTER //
// ./src/components/sight/sight.vue